import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { InputSwitch } from 'primereact/inputswitch';
import { Dropdown } from 'primereact/dropdown';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { connect } from 'react-redux';
import Messages from '../../../shared/UI/Messages/Messages';
import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddKitchenMaster extends Component {
    state = {
        type: 'add',
        kitchenId: null,
        isActive: false,
        kitchenCode: '',
        kitchenName: '',
        kitchenType: null,
        locationId: null,
        outletId: null,
        // Whether a KOT actually goes to this kitchen's printer. Loaded,
        // saved and reset already — this is just the initial value.
        ToPrint: false,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        createdBy: this.props.loggedUserDetail.userName ?? 'Admin',
        createdDate: new Date(),
        touch: false,
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        let id = this.props.match.params.id;
        this.props.getMasterTableList('res/GetResKitchenbyid?KitchenId=' + id, this.props.loggedUserDetail.CompanyId);
        this.props.getMasterKeywordList('Printer');
        this.props.getMasterKeywordList('branch');
        this.props.getMasterKeywordList('location');
        let type = this.props.match.params.type;

        // if (type !== 'add') {
        //     this.timer();
        // }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.tableLists !== this.props.tableLists && this.props.tableLists) {
            let type = this.props.match.params.type;
            let filterData = this.props.tableLists;
            this.setState({
                type: type,
                kitchenId: filterData.kitchenId,
                isActive: filterData.isActive,
                kitchenCode: filterData.kitchenCode,
                kitchenName: filterData.kitchenName,
                kitchenType: filterData.kitchenType,
                locationId: filterData.locationId,
                outletId: filterData.outletId,
                PrinterId: filterData.PrinterId,
                ToPrint: filterData.ToPrint,
            });
        }
    }

    // timer = () => {
        
    //     this.intervalID = setInterval(() => {
    //         this.fetchSingleProcess();
    //         this.setState({ loading: false });
    //     },1000);
    // }

    componentWillUnmount() {
        if (this.props.tableLists !== undefined) {
            clearInterval(this.intervalID);
        }
    }

    // fetchSingleProcess = () => {
    //     this.setState({ loading: true});
    //         console.log('tableLists:', this.props.tableLists);

    //     let type = this.props.match.params.type;
    //     let storageItems = [];
    //     if (this.props.tableLists !== undefined) {
    //         storageItems = this.props.tableLists;
    //         clearInterval(this.intervalID);
    //     }
    //     if (storageItems) {
    //         let filterData = storageItems;
    //         if (filterData) {
    //             this.setState({
    //                 type: type,
    //                 menuKitchenId: filterData.menuCategoryId,
    //                 isActive: filterData.isActive,
    //                 categorycode: filterData.categorycode,
    //                 categoryName: filterData.categoryName,
    //             });
    //         }
    //     }
    // }

    change = (e) => {
        let { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    add = () => {
        var data = {
            companyid: this.state.CompanyId,
            isActive: this.state.isActive,
            kitchenCode: this.state.kitchenCode,
            kitchenName: this.state.kitchenName,
            kitchenType: this.state.kitchenType,
            locationId: "55633610-cb32-4a84-8ea9-20b04252d98d",
            outletId: this.state.outletId,
            PrinterId: this.state.PrinterId,
            ToPrint: this.state.ToPrint,
            createdBy: this.state.createdBy,
            createdDate: this.state.createdDate,
        };

        if (this.state.type === 'edit') {
            data.kitchenId = this.state.kitchenId;
        }

        this.props.processDynamicData('ResKitchen', this.state.type, data, 'res/GetResKitchenbyid');
    }

    resetData = () => {
        this.setState({
            kitchenId: null,
            isActive: false,
            kitchenCode: '',
            kitchenName: '',
            kitchenType: null,
            locationId: null,
            outletId: null,
            PrinterId: null,
            ToPrint: false,
            type: 'add',
            touch: false,
        });
    }

    render() {
        if (this.props.success) {
            REDIRECT_TO_URL('/kitchen/', this.props);
        }

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false && this.props.userDetail.userId !== this.props.match.params.id) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess };

        let isEnabled = this.state.touch === true;
        let isViewMode = this.state.type === 'view';

        let redirectURL = '/kitchen/';
        if (this.props.userDetail && this.props.match.params.id !== undefined) {
            if (this.props.userDetail.userId === this.props.match.params.id) {
                redirectURL = '/dashboard';
            }
        }

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type} Item</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-12">
                                <div className="card card-w-title">
                                    <div className="p-grid">

                                        {/* isActive - Switch */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="isActive">Is Active</label>
                                            <div className="mt1">
                                                <InputSwitch
                                                    id="isActive"
                                                    name="isActive"
                                                    checked={this.state.isActive}
                                                    disabled={isViewMode}
                                                    onChange={(e) => this.setState({ isActive: e.value, touch: true })}
                                                />
                                            </div>
                                        </div>

                                        {/* kitchenCode - InputText */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="kitchenCode">Kitchen Code <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="kitchenCode"
                                                    name="kitchenCode"
                                                    value={this.state.kitchenCode}
                                                    onChange={this.change}
                                                    placeholder="Kitchen Code"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>

                                        {/* kitchenName - InputText */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="kitchenName">Kitchen Name <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="kitchenName"
                                                    name="kitchenName"
                                                    value={this.state.kitchenName}
                                                    onChange={this.change}
                                                    placeholder="Kitchen Name"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>

                                        {/* kitchenType - InputText */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="kitchenType">Kitchen Type <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <InputText
                                                    className="p-col-12"
                                                    id="kitchenType"
                                                    name="kitchenType"
                                                    value={this.state.kitchenType}
                                                    onChange={this.change}
                                                    placeholder="Kitchen Type"
                                                    disabled={isViewMode}
                                                />
                                            </div>
                                        </div>

                                        {/* Printer  - Dropdown */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="PrinterId">Printer </label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="PrinterId"
                                                    name="PrinterId"
                                                    options={this.props.Printer || []}
                                                    value={this.state.PrinterId}
                                                    onChange={(e) => this.setState({ PrinterId: e.value, touch: true })}
                                                    placeholder="Select Printer"
                                                    disabled={isViewMode}
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* ToPrint - Checkbox */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="labeltop" htmlFor="ToPrint">To Print</label>
                                            <div className="mt1">
                                                <Checkbox
                                                    inputId="ToPrint"
                                                    name="ToPrint"
                                                    checked={!!this.state.ToPrint}
                                                    disabled={isViewMode}
                                                    onChange={(e) => this.setState({ ToPrint: e.checked, touch: true })}
                                                />
                                                <label htmlFor="ToPrint" className="label ml1">Print KOT on this kitchen's printer</label>
                                            </div>
                                        </div>

                                        {/* locationId - Dropdown */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="locationId">Location <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="locationId"
                                                    name="locationId"
                                                    options={this.props.location || []}
                                                    value={this.state.locationId}
                                                    onChange={(e) => this.setState({ locationId: e.value, touch: true })}
                                                    placeholder="Select Location"
                                                    disabled={isViewMode}
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                        {/* outletId - Dropdown */}
                                        <div className="p-col-12 p-md-6 p-lg-4">
                                            <label className="label" htmlFor="outletId">Outlet <span className="requiredColor">*</span></label>
                                            <div className="mt1">
                                                <Dropdown
                                                    className="p-col-12"
                                                    id="outletId"
                                                    name="outletId"
                                                    options={this.props.branch || []}
                                                    value={this.state.outletId}
                                                    onChange={(e) => this.setState({ outletId: e.value, touch: true })}
                                                    placeholder="Select Outlet"
                                                    disabled={isViewMode}
                                                    {...DROPDOWN_CONFIG}
                                                />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                        <div className="p-col-12 p-lg-12">
                                          <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.add} reset={this.resetData}  to={redirectURL} />
                                        </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        unitList: state.keyword.unit,
        branch: state.keyword.branch,
        location: state.keyword.location,
        Printer: state.keyword.Printer,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterTableList: (table, companyId) => dispatch(actions.getMasterTableList(table, companyId)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddKitchenMaster);